/**
 * On-demand AI call actions — Generate/Regenerate insight and Transcribe — hit
 * the operations write endpoints (`messages:edit`), which forward to the calling
 * service. The CS enabled `summary`/`transcribe` for notifi-2.0 accounts in its
 * rollout, so these are ON by default now (matching the legacy 1.0 call view).
 *
 * Kept as an opt-OUT kill switch: set `VITE_CALL_AI_ACTIONS=false` to hide the
 * actions in an environment whose calling service hasn't picked up that rollout
 * yet (the endpoints would 400 there). The sections still render any insight /
 * transcript already produced by the CS pipeline regardless of this flag.
 */
export const CALL_AI_ACTIONS_ENABLED = import.meta.env.VITE_CALL_AI_ACTIONS !== 'false';
